module.exports = __webpack_public_path__ + "static/media/unsubscribe.a47611b1.svg";